import { Component, OnInit } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-login',
  template: `<p>リダイレクト中です...</p>`,
})
export class LoginComponent implements OnInit {
  ngOnInit(): void {
    // リダイレクト先を指定（必要に応じてクエリパラメータも対応）
    window.location.href = 'https://myfxpool.com/';
  }
}
